import {MESSAGE_TYPE} from '@constants/message-type';

export class NotificationMessage {
  type: string = MESSAGE_TYPE.WARNING;
  message: string = '';
}